export default "__VITE_ASSET__0a19f628__"